<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 18.006 18.006"
  >
    <path
      fill="currentColor"
      d="m17.71 16.29-3.4-3.39A7.92 7.92 0 0 0 16 8a8 8 0 1 0-8 8 7.92 7.92 0 0 0 4.9-1.69l3.39 3.4a1.004 1.004 0 1 0 1.42-1.42ZM2 8a6 6 0 1 1 6 6 6 6 0 0 1-6-6Z"
    />
  </svg>
</template>
